import i18n from 'i18next';
import appsEn from './en-US/apps.json';
import bookMenusEn from './en-US/bookMenus.json';
import commonEn from './en-US/common.json';
import copyrightEn from './en-US/copyright.json';
import errorsEn from './en-US/errors.json';
import footerEn from './en-US/footer.json';
import homeEn from './en-US/home.json';
import modalsEn from './en-US/modals.json';
import navEn from './en-US/nav.json';
import resourcesEn from './en-US/resources.json';
import selectEn from './en-US/select.json';
import supportEn from './en-US/support.json';
import lessonPlannerEn from './en-US/lessonPlanner.json';
import lessonAssignmentEn from './en-US/lessonAssignment.json';
import assignmentTrackerEn from './en-US/assignmentTracker.json';
import tourEn from './en-US/tour.json';
import appsEs from './es-US/apps.json';
import bookMenusEs from './es-US/bookMenus.json';
import commonEs from './es-US/common.json';
import copyrightEs from './es-US/copyright.json';
import errorsEs from './es-US/errors.json';
import footerEs from './es-US/footer.json';
import homeEs from './es-US/home.json';
import modalsEs from './es-US/modals.json';
import navEs from './es-US/nav.json';
import resourcesEs from './es-US/resources.json';
import selectEs from './es-US/select.json';
import supportEs from './es-US/support.json';
import lessonPlannerEs from './es-US/lessonPlanner.json';
import lessonAssignmentEs from './es-US/lessonAssignment.json';
import assignmentTrackerEs from './es-US/assignmentTracker.json';
import tourEs from './es-US/tour.json';
import { initReactI18next } from 'react-i18next';
import invert from 'lodash/invert';
import { translationNamespace } from './variants/namespace';

export const localeToLanguage = {
  'en-US': 'english',
  'es-US': 'español'
};
const translatedBookCodes = {
  'en-US': {
    MMHATS: 'MMHATS',
    MMGO: 'MMGO',
    MMSH: 'MMSH',
    MMOPP: 'MMOPP',
    TGRW: 'TGRW',
    TGPKGSS1: 'TGPKGSS1',
    TGPKGSS: 'TGPKGSS',
    MFSB: 'MFSB',
    MFLB: 'MFLB',
    MB: 'MB',
    // FROM HITT
    IKMN: 'IKMN',
    KSK: 'KSK',
    TGKSK: 'TGKSK',
    LN: 'LN',
    TGLN: 'TGLN',
    MPB: 'MPB',
    TGMPB: 'TGMPB',
    PP: 'PP',
    TGPP: 'TGPP',
    CK: 'CK',
    TGCK: 'TGCK',
    CH: 'CH',
    TGCH: 'TGCH',
    CS: 'CS',
    TGCS: 'TGCS',
    DC: 'DC',
    TGDC: 'TGDC'
  },
  'es-US': {
    MMHATS: 'SMMHATS',
    MMGO: 'SMMGO',
    MMSH: 'SMMSH',
    MMOPP: 'SMMOPP',
    TGRW: 'STGRW',
    TGPKGSS1: 'STGPKGSS1',
    TGPKGSS: 'STGPKGSS',
    MFSB: 'SMFB',
    MFLB: 'SMFLB',
    MB: 'SMB',
    // FROM HITT
    IKMN: 'SIKMN',
    KSK: 'KSK',
    TGKSK: 'TGSCK',
    LN: 'SKLY',
    TGLN: 'TGSKLY',
    MPB: 'S1MLI',
    TGMPB: 'TGS1MLI',
    PP: 'S2EPI',
    TGPP: 'TGS2EPI',
    CK: 'S2AC',
    TGCK: 'TGS2AC',
    CH: 'S3EC',
    TGCH: 'TGS3EC',
    CS: 'S4XC',
    TGCS: 'TGS4XC',
    DC: 'S5DC',
    TGDC: 'TGS5DC'
  }
};
i18n.use(initReactI18next).init(
  {
    lng: 'en-US',
    resources: {
      'en-US': {
        translation: {
          apps: appsEn,
          bookMenus: bookMenusEn,
          common: commonEn,
          copyright: copyrightEn,
          errors: errorsEn,
          footer: footerEn,
          home: homeEn,
          modals: modalsEn,
          nav: navEn,
          resources: resourcesEn,
          select: selectEn,
          support: supportEn,
          lessonPlanner: lessonPlannerEn,
          lessonAssignment: lessonAssignmentEn,
          assignmentTracker: assignmentTrackerEn,
          tour: tourEn
        }
      },
      'es-US': {
        translation: {
          apps: appsEs,
          bookMenus: bookMenusEs,
          common: commonEs,
          copyright: copyrightEs,
          errors: errorsEs,
          footer: footerEs,
          home: homeEs,
          modals: modalsEs,
          nav: navEs,
          resources: resourcesEs,
          select: selectEs,
          support: supportEs,
          lessonPlanner: lessonPlannerEs,
          lessonAssignment: lessonAssignmentEs,
          assignmentTracker: assignmentTrackerEs,
          tour: tourEs
        }
      }
    }
  },
  e => console.log(e)
);

const translator = i18n;
export default translator;

export const getTranslatedImage = (imageName: string) => {
  const locale = i18n.language;

  return require(`assets/images/translatedImages/${locale}/${imageName}`);
};

export const translate = (namespace: translationNamespace, key: string, options?): string => {
  const trans = i18n.t(`${namespace}.${key}`, options);
  return trans as string;
};

export const getSpecificTranslation = (
  locale: string,
  namespace: string,
  text: string,
  options?: any
): string => {
  const translateForLocale = i18n.getFixedT(locale, namespace);

  return translateForLocale(text, options) as string;
};

export const setLocale = (locale: string) => {
  i18n.changeLanguage(locale);
};

export const getLocale = (): string => {
  const locale = i18n.language;
  return locale;
};

export const translateBookCode = (
  oldLocale: string,
  newLocale: string,
  bookCode: string
): string => {
  const oldLocaleBookCodes = invert(translatedBookCodes[oldLocale]);
  return translatedBookCodes[newLocale][oldLocaleBookCodes[bookCode]];
};
